import { useMemo } from "react";
import { useFeatureTernary } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";

export enum MarqueeExperimentFiltersPlacement {
  Bottom,
  Top,
}

export const useMarqueeExperimentFiltersPlacement = () => {
  const resolver = useFeatureTernary(FeatureSetEnum.CXWD_3214_HomepageFiltersPlacementDesktop);
  return useMemo(
    () =>
      resolver({
        control: () => MarqueeExperimentFiltersPlacement.Bottom,
        variant: () => MarqueeExperimentFiltersPlacement.Top,
      }) ?? MarqueeExperimentFiltersPlacement.Bottom,
    [resolver],
  );
};
